window.initTestimonialSlider ?? (() => {
    window.initTestimonialSlider = (section_id, card_sizes, heart_image) => {
        const testimonialSliderSection = document.querySelector(`section#shopify-section-${section_id} .careline-20-testimonials`);
        const cardSizes = card_sizes.split('|');

        function getAfterOffset() {
            if (!heart_image) return 0;
            const styles = window.getComputedStyle(testimonialSliderSection);
            const paddingLeft = parseFloat(styles.paddingLeft);
            const containerWidth = Math.min(testimonialSliderSection.offsetWidth, window.innerWidth);
            const viewportWidth = window.innerWidth;
            const outerMargin = Math.max((viewportWidth - containerWidth) / 2, 0);
            //return (outerMargin + paddingLeft > 300)? outerMargin + paddingLeft : 300;
            //return (outerMargin + paddingLeft > 120)? outerMargin + paddingLeft : 120;
            return 0;
        }

        function getBeforeOffset() {
            if (!heart_image) return 0;
            return window.innerWidth > 990 ? 120 : 0;
        }

        const swiper = new Swiper('.careline-20-testimonials-swiper', {
            slidesPerView: parseFloat(cardSizes[0]),
            spaceBetween: 15,
            overflow: 'visible',
            loop: false,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: false,
            slidesOffsetBefore: getBeforeOffset(),
            slidesOffsetAfter: getAfterOffset(),
            breakpoints: {
                500: {
                    slidesPerView: parseFloat(cardSizes[1]),
                    spaceBetween: 15,
                },
                750: {
                    slidesPerView: parseFloat(cardSizes[2]),
                    spaceBetween: 15,
                },
                990: {
                    slidesPerView: parseFloat(cardSizes[3]),
                    spaceBetween: 20,
                },
                1200: {
                    slidesPerView: parseFloat(cardSizes[4]),
                    spaceBetween: 30,
                },
                1400: {
                    slidesPerView: parseFloat(cardSizes[5]),
                    spaceBetween: 30,
                }
            }
        });

        window.addEventListener('resize', () => {
            swiper.params.slidesOffsetBefore = getBeforeOffset();
            swiper.params.slidesOffsetAfter = getAfterOffset();
            swiper.update();
        });
    }
  
})();